import actions from '../action/global_shopping'
import CONSTANT from '../constant/global_shopping'
import { Toast } from 'mint-ui'
export default {
    actions,
    state: {

    },
    getters: {

    },
    mutations: {
        [CONSTANT.GLOBAL_SHOPPING_GETGLOBALMENUS_SUCCESS] (state, data) {
        },
        [CONSTANT.GLOBAL_SHOPPING_GETGLOBALMENUS_ERROR] (state, e) {
        },
        [CONSTANT.GLOBAL_SHOPPING_GETGLOBALSHOPPINGRECOMMEND_SUCCESS] (state, data) {
        },
        [CONSTANT.GLOBAL_SHOPPING_GETGLOBALSHOPPINGRECOMMEND_ERROR] (state, e) {
        },
        /*yeoman-template-point-1*/
    }
}
